import { render, staticRenderFns } from "./AlertView.vue?vue&type=template&id=18f7b8c5&scoped=true"
import script from "./AlertView.vue?vue&type=script&lang=js"
export * from "./AlertView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f7b8c5",
  null
  
)

export default component.exports